<template>
  <ValidationProvider
    :class="['form__control', className]"
    :rules="rules"
    tag="div"
    ref="provider"
    v-slot="{}"
  >
    <div
      class="d-flex counter"
      :class="{ 'counter--disabled': disabled }"
      :data-uiid="dataUiid"
      :aria-label="ariaLabel"
    >
      <v-btn
        :ripple="false"
        color="webgrey"
        class="elevation-0"
        :disabled="
          answerControlCounterOptions.Count ===
            answerControlCounterOptions.CountMinValue || disabled
        "
        @click="decreaseCounter"
        aria-label="Decrease counter value"
      >
        <v-icon color="white">mdi-minus</v-icon>
      </v-btn>
      <v-card class="elevation-0">
        <label class="font-20 font-weight-bold">{{
          answerControlCounterOptions.CountValues[
            answerControlCounterOptions.Count
          ].DisplayValue
        }}</label>
      </v-card>
      <v-btn
        :ripple="false"
        color="webgrey"
        class="elevation-0"
        :disabled="
          answerControlCounterOptions.Count ===
            answerControlCounterOptions.CountMaxValue || disabled
        "
        @click="increaseCounter"
        aria-label="Increase counter value"
      >
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  name: "CounterBaseQuestion",
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    rules: {
      type: Object,
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
    dataUiid: {
      type: String,
      required: true,
    },
    answerControlCounterOptions: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: String,
  },
  data() {
    return {
      innerValue: "",
    };
  },
  watch: {
    innerValue(value) {
      this.$emit("input", value);
    },
    value(value) {
      this.findAndIncreaseCounterByValue(value);
      this.setValue();
    },
  },
  methods: {
    increaseCounter() {
      if (
        this.answerControlCounterOptions.Count <
        this.answerControlCounterOptions.CountMaxValue
      ) {
        this.answerControlCounterOptions.Count += 1;
        this.setValue();
        this.$emit("change", this.answerControlCounterOptions.Count);
      }
    },
    decreaseCounter() {
      if (
        this.answerControlCounterOptions.Count >
        this.answerControlCounterOptions.CountMinValue
      ) {
        this.answerControlCounterOptions.Count -= 1;
        this.setValue();
        this.$emit("change", this.answerControlCounterOptions.Count);
      }
    },
    setValue() {
      this.innerValue =
        this.answerControlCounterOptions.CountValues[
          this.answerControlCounterOptions.Count
        ].Value;
    },
    syncValue(value) {
      this.findAndIncreaseCounterByValue(value);
      this.setValue();
    },
    findAndIncreaseCounterByValue(value) {
      // Value already set from outside, sync the counter
      const countValues = this.answerControlCounterOptions.CountValues;
      let countOptions;
      for (const key in countValues) {
        if (countValues[key].Value === value) {
          countOptions = key;
          break;
        }
      }

      if (!countOptions) return;

      this.answerControlCounterOptions.Count = +countOptions;
    },
  },
  created() {
    this.syncValue(this.value);
  },
};
</script>

<style lang="scss" scoped>
.counter.counter--disabled {
  opacity: 0.6;
}
</style>
